import { jsx as H } from "react/jsx-runtime";
import { c as o } from "./index-65016bfa.mjs";
import { useRef as $, useEffect as E } from "react";
import r from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as M } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
var g = /* @__PURE__ */ ((t) => (t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t))(g || {}), j = /* @__PURE__ */ ((t) => (t.Display1 = "display-1", t.Display2 = "display-2", t.Display3 = "display-3", t))(j || {}), s = /* @__PURE__ */ ((t) => (t.Display1 = "display-1", t.Display2 = "display-2", t.Display3 = "display-3", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.Title = "title", t.Subtitle = "sub-title", t.P = "p", t.Ul = "ul", t.Ol = "ol", t.Li = "li", t.A = "a", t.Caption = "caption", t.Table = "table", t))(s || {});
const x = r.h1.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, "display-1", e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h1
), p = r.h2.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, "display-2", e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h2
), b = r.h3.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, "display-3", e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h3
), A = r.h1.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h1
), N = r.h2.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h2
), f = r.h3.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h3
), T = r.h4.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h4
), D = r.h5.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h5
), S = r.h6.attrs(({ className: t, fontWeight: e = "medium", ...l }) => ({
  ...l,
  className: o("Text", t, e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h6
), q = r.h4.attrs(({ className: t, fontWeight: e = "medium", ...l }) => ({
  ...l,
  className: o("Text", t, "title", e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h4
), w = r.h5.attrs(({ className: t, ...e }) => ({
  ...e,
  className: o("Text", t, "sub-title")
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.h5
), P = r.p.attrs(({ className: t, fontWeight: e = "regular", size: l = "medium", ...c }) => ({
  ...c,
  className: o("Text", t, e, `${l}-text`)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.p
), C = r.ul.attrs(({ className: t, ...e }) => ({
  ...e,
  className: o("Text", t)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.ul
), L = r.ol.attrs(({ className: t, ...e }) => ({
  ...e,
  className: o("Text", t)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.ol
), O = r.li.attrs(({ className: t, fontWeight: e = "regular", size: l = "medium", ...c }) => ({
  ...c,
  className: o("Text", t, e, `${l}-text`)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.p
), R = r.a.attrs(({ className: t, ...e }) => ({
  ...e,
  className: o("Text", t)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.a
), U = r.caption.attrs(({ className: t, fontWeight: e = "regular", ...l }) => ({
  ...l,
  className: o("Text", t, "caption", e)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.caption
), I = r.table.attrs(({ className: t, ...e }) => ({
  ...e,
  className: o("Text", t)
}))(
  ({
    theme: {
      components: { richText: t }
    }
  }) => t.table
), Q = (t) => {
  if (t)
    try {
      const e = t.querySelectorAll("th");
      for (let a = 0; a < e.length; a++)
        e[a].setAttribute("role", "columnheader");
      const l = t.querySelectorAll("thead, tbody, tfoot");
      for (let a = 0; a < l.length; a++)
        l[a].setAttribute("role", "rowgroup");
      const c = t.querySelectorAll("tr");
      for (let a = 0; a < c.length; a++) {
        c[a].setAttribute("role", "row");
        const i = c[a].querySelectorAll("td");
        for (let m = 0; m < i.length; m++)
          i[m].setAttribute("data-cell", i[m].dataset.cell ?? e[m].innerText), i[m].setAttribute("data-title", i[m].dataset.cell ?? e[m].innerText);
      }
      const u = t.querySelectorAll("td");
      for (let a = 0; a < u.length; a++)
        u[a].setAttribute("role", "cell");
      const h = t.querySelectorAll("th[scope=row]");
      for (let a = 0; a < h.length; a++)
        h[a].setAttribute("role", "rowheader");
    } catch (e) {
      console.log("AddTableARIA(): " + e);
    }
};
function v(t) {
  const e = $(null);
  return E(() => Q(e == null ? void 0 : e.current), []), /* @__PURE__ */ H(
    I,
    {
      ...t,
      ref: e,
      role: "table",
      className: o(["Table", t.className])
    }
  );
}
const d = {
  [s.Display1]: x,
  [s.Display2]: p,
  [s.Display3]: b,
  [s.H1]: A,
  [s.H2]: N,
  [s.H3]: f,
  [s.H4]: T,
  [s.H5]: D,
  [s.H6]: S,
  [s.Title]: q,
  [s.Subtitle]: w,
  [s.P]: P,
  [s.A]: R,
  [s.Ul]: C,
  [s.Ol]: L,
  [s.Li]: O,
  [s.Caption]: U,
  [s.Table]: v
};
function n({ as: t = `${s.P}`, renderAs: e = t, ...l }) {
  const c = M({ label: "Text" }), u = d[e] || d[s.P];
  return /* @__PURE__ */ H(
    u,
    {
      ...l,
      ...c
    }
  );
}
n.Display1 = x;
n.Display2 = p;
n.Display3 = b;
n.H1 = A;
n.H2 = N;
n.H3 = f;
n.H4 = T;
n.H5 = D;
n.H6 = S;
n.Title = q;
n.SubTitle = w;
n.P = P;
n.Ul = C;
n.Ol = L;
n.Li = O;
n.A = R;
n.Caption = U;
n.Table = v;
export {
  R as A,
  U as Caption,
  x as Display1,
  p as Display2,
  b as Display3,
  j as DisplayTypoGraphy,
  A as H1,
  N as H2,
  f as H3,
  T as H4,
  D as H5,
  S as H6,
  g as HeadingTypoGraphy,
  O as Li,
  L as Ol,
  P,
  I as StyledTable,
  w as SubTitle,
  v as Table,
  n as Text,
  q as Title,
  s as Typography,
  C as Ul
};
